import { useMeasure } from "react-use";

export const useElementQueries = sizes => {
    const [ref, { width }] = useMeasure();
    const minWidth = sizes.filter(size => width >= size).join(" ");
    return [ref, { attrs: { "data-min-width": minWidth } }];
};

export const getDaysCount = itineraryData => {
    try {
        const overnightStops = itineraryData?.stops?.filter(
            stop => stop?.stopType?.label?.toUpperCase() === "OVERNIGHT",
        );
        const sum = overnightStops.reduce((sum, item) => {
            return sum + parseInt(item?.multiNight?.numberOfNights ?? 1);
        }, 0);
        //Add 1 because last stop isn't overnight
        return sum + 1;
    } catch (error) {
        console.warn(error);
        return 0;
    }
};

export const getDistance = itineraryData => {
    try {
        const distance = itineraryData.stops
            .filter(item => item.type === "stop")
            .reduce((result, item, index) => {
                if (index === 0) {
                    return result;
                }
                const itemDistance = item.type === "stop" && item?.distanceFromPrevStop;
                if (itemDistance) {
                    return result + itemDistance / 1000;
                }
                return result;
            }, 0);
        return parseInt(distance);
    } catch (error) {
        console.warn(error);
        return 0;
    }
};

// Add attributes target="_blank" and rel="noopener noreferrer" to every <a /> tag
export const decorateRichText = html => {
    if (!html || typeof html !== "string") {
        return html;
    }
    const domParser = new DOMParser();
    const document = domParser.parseFromString(html, `text/html`);

    // Handles external links
    const links = document.querySelectorAll(`a`);

    links.forEach(link => {
        if (link.href) {
            link.target = `_blank`;
            link.rel = `noopener noreferrer`;
        }
    });
    const newHtml = document.body.innerHTML;
    return newHtml;
};
